import React,{useState,useRef} from 'react';
import {ListGroup,Nav,Col,OverlayTrigger,Popover,Spinner, Container,Navbar,Button,Card, Form, Row, Badge, CardColumns, Jumbotron} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import TimeAgo from './TimeAgo';
import Swal from 'sweetalert2';
import icon from './icon.png';
import kadum from './kadum.jpg';

import AceEditor from 'react-ace';

import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-java";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-python";
import "ace-builds/src-noconflict/mode-sass";
import "ace-builds/src-noconflict/mode-markdown";

import "ace-builds/src-noconflict/theme-monokai";
import "ace-builds/src-noconflict/ext-language_tools"


import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

import {useAuthState} from 'react-firebase-hooks/auth'
import {useCollectionData} from 'react-firebase-hooks/firestore';

// Initialize Firebase
firebase.initializeApp({
  apiKey: "AIzaSyAezJq2YJAeBdjviTyucAg-WIjrH5k4Rms",
  authDomain: "todolist-883c4.firebaseapp.com",
  projectId: "todolist-883c4",
  storageBucket: "todolist-883c4.appspot.com",
  messagingSenderId: "426999076247",
  appId: "1:426999076247:web:15741f959fbe503db360d2"
});



const auth = firebase.auth();
const firestore = firebase.firestore();


let tabIndex = 1;
const App = () =>{
 
  const [user,loading] = useAuthState(auth);
  const [tab,setTab] = useState(1);

  const signInWithGoogle = () =>{
    const provider = new firebase.auth.GoogleAuthProvider();//firebase
    auth.signInWithPopup(provider);//hooks
  }

  const route = (e,t) =>{
    e.preventDefault();
    setTab(t);
    tabIndex=t;
  }

  React.useEffect(() => {
    window.addEventListener("keydown", (e)=>downHandler(e));
    return () => {
      window.removeEventListener("keydown", downHandler);
    };
  },[auth]);
  const downHandler = (e) =>{
        switch(e.keyCode) { 
          case 37: 
                if(tabIndex>=2){
                  setTab(prev=>prev-1);
                  tabIndex--;
                }
              break; 
          case 39: 
                if(tabIndex<=3){
                  setTab(prev=>prev+1);
                  tabIndex++;                  
                }
              break; 
          default:
      } 
  }
 
  

  return(
        <Container fluid>
         
            
            <Navbar collapseOnSelect expand="lg" sticky="top" bg="light" as="div">
              <Navbar.Brand ><strong><img src={icon} style={{with:'50px',height:'50px'}} alt="todo list icon"/> PENSNIPPET</strong></Navbar.Brand>
              <Navbar.Toggle aria-controls="responsive-navbar-nav" />
              <Navbar.Collapse className="justify-content-end">
              {user&&
              <Nav className="mr-auto">
                <Nav.Link as="a" style={{color:tab===1?'red':null}} onClick={(e)=>route(e,1)} href="?type=home">
                  <i className="fas fa-home"></i> Home
                </Nav.Link>
                <Nav.Link style={{color:tab===2?'red':null}} onClick={(e)=>route(e,2)} href="?type=mytask">
                 <i className="fas fa-code"></i> My Snippets
                </Nav.Link>
                <Nav.Link style={{color:tab===3?'red':null}} onClick={(e)=>route(e,3)} href="?type=mytask">
                 <i className="fas fa-plus-circle"></i> Add Snippets
                </Nav.Link>
                <Nav.Link style={{color:tab===4?'red':null}} onClick={(e)=>route(e,4)} href="?type=mytask">
                 <i className="fab fa-dev"></i> Developer
                </Nav.Link>
                <Nav.Link onClick={()=>alert("Use Left and Right arrow keys to navigate through the navigation bar!")} style={{color:'green'}}>
                    <i className="fas fa-info-circle"></i> hint
                </Nav.Link>
              </Nav>
              }

                <Navbar.Text>
                  {loading?
                  <Spinner variant="primary" animation="border" role="status">
                    <span className="sr-only">Loading...</span> 
                  </Spinner>:
                  user?
                    <>&nbsp;
                    <OverlayTrigger trigger="hover" key="bottom" placement="bottom" overlay={
                      <Popover id={`popover-positioned-bottom`}>
                        <Popover.Title as="h3">Hi iam {auth.currentUser.displayName}</Popover.Title>
                        <Popover.Content>
                          <strong>Holy Moly!</strong> Iam cool.
                        </Popover.Content>
                      </Popover>}>
                        <img style={{width:"40px",height:"40px",borderRadius:"50%"}} src={auth.currentUser.photoURL} alt={auth.currentUser.displayName}/>
                    </OverlayTrigger> &nbsp;&nbsp;&nbsp;<Badge variant="danger" style={{cursor:"pointer"}} onClick={()=>auth.signOut()}>SignOut</Badge> 
                      </>:
                    <Button onClick={signInWithGoogle} variant="danger" size="sm">
                      <i className="fab fa-google"></i> &nbsp;Sign in with Google
                    </Button>}
                </Navbar.Text>
              </Navbar.Collapse>
            </Navbar>

          {user&&<>
                  {
                    tab===1?<CardColumns >
                      <Post />
                    </CardColumns>
                    :tab===2?<>
                    {user &&<TodoData />}
                    </>
                    :tab===3?<AddTodo setTab={setTab} user={user}/>
                    :<Developer />
                  }
                </>
          }

          
          {!user&&!loading&&
            <Jumbotron>
            <h1>Welcome to PenSnippet!</h1>
            <p>
              This is a code snippet list app where you can add your favourite code snippets and come visit whenever you want it.
            </p>
            <p>
              <Button variant="danger" onClick={signInWithGoogle}>
                Get stated <i className="fas fa-angle-double-right"></i>
              </Button>
              <Button href="https://github.com/kadmon47/PenTodo" style={{marginLeft:"12px"}} title="github code">
                <i className="fas fa-code"></i> code 
              </Button>
              <Button href="https://github.com/kadmon47" style={{marginLeft:"12px"}} title="github code">
                <i className="fab fa-github"></i> Developer Page - GitHub
              </Button>
            </p>
          </Jumbotron>
          }
             
        </Container>
  );
}

const Developer = () =>{
  return(
      <div style={{marginTop:"10px",display:"flex",justifyContent:"center",alignItems:"center"}}>
       <Card style={{maxWidth:'400px'}}>
  <Card.Img variant="top" src={kadum} />
  <Card.Body>
    <Card.Title>Kadum Komut</Card.Title>
    <Card.Text>
       github - <a href="https://github.com/kadmon47">https://github.com/kadmon47</a>
    </Card.Text>
    <Button variant="primary" href="https://github.com/kadmon47/PenTodo">Go to code</Button>
  </Card.Body>
</Card>
</div>
  );
}

const Post = ()=>{
  const [post,loading] = useCollectionData(firestore.collection('home'),{idField:"id"});
  return(<>
    {
      loading?<Spinner variant="primary" animation="border" role="status"><span className="sr-only">Loading...</span> </Spinner>:
        post&&post.map(list=>(
          <PostList createdAt={list.createdAt} text={list.text} complete={list.completed} uid={list.uid} photo={list.photo} name={list.name} key={list.id}/>
        ))
    }
    </>
  );
}

const PostList = ({createdAt,text,complete,uid,photo,name}) =>{
  return(
    <Card style={{marginTop:"10px"}}>
      <Card.Header as="h5" style={{background:'#222',color:'white'}}>
        <img src={photo} alt={name} style={{width:'40px',height:"40px",borderRadius:"50%"}}/> {name}
      </Card.Header>
      <Card.Body style={{background:"#222",color:'white',whiteSpace:"pre-wrap"}}>
        <Card.Text >
          {text}
        </Card.Text>
        <Button variant={complete?'success':'danger'} size="sm">{complete?<><span>completed</span> <i className="far fa-check-circle"></i></>:<><span>Not completed</span> <i className="fas fa-clock"></i></>}</Button>
      </Card.Body>
      <Card.Footer style={{background:'#222',color:'white'}}>
        <small>{new Date(createdAt).toString().slice(4,24)}</small>
      </Card.Footer>
    </Card>
  );
}

const AddTodo = ({user,setTab})=>{
  const [mode,setMode] = useState("javascript");
  const [data,setData] = useState("");
  const submitTask = (e) =>{
    e.preventDefault();
    if(data==="") return;
    Swal.fire({
      title:"Add Todo",
      text:data,
      icon:'question',
      confirmButtonText:"Add",
      showCancelButton:true,
      preConfirm:async()=>{
         return await firestore.collection('todoList').doc(auth.currentUser.uid).collection('list').add({
           text:data,
           createdAt:Date.now(),
           completed:false
         }).then(async(snap)=>{
           await firestore.collection('home').doc(snap.id).set({
            text:data,
            createdAt:Date.now(),
            completed:false,
            uid:auth.currentUser.uid,
            photo:auth.currentUser.photoURL,
            name:auth.currentUser.displayName
           })
         });
      },
      showLoaderOnConfirm:true
    }).then(res=>{
      if(res.value){
        setData("");
        Swal.fire({
          title:"Task Completed",
          icon:'success',
        }).then(res=>{
          if(res.isConfirmed){
            setTab(2);
            tabIndex=2;
          }
        })
      }
    })
    
}
const onChange = (newValue) =>{
  setData(newValue)
}
  return(
    <Container>

    <Form onSubmit={submitTask} style={{marginTop:"20px"}}>
    <Form.Group>
        <Form.Control onChange={(e)=>setMode(e.target.value)} as="select" style={{marginBottom:"10px",background:"#222",color:'white'}}>
          <option>javascript</option>
          <option>java</option>
          <option>html</option>
          <option>python</option>
          <option>css</option>
          <option>sass</option>
          <option>markdown</option>
        </Form.Control>
        <AceEditor
          value={data}
          onChange={onChange}
          mode={mode}
          fontSize="16px"
          width="100%"
          wrapEnabled={true}
          theme="monokai"
          setOptions={{
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true,
            enableSnippets: true
          }}
          name="UNIQUE_ID_OF_DIV"
          editorProps={{ $blockScrolling: true }}
        />
        <Button variant="primary"  type="submit"><i className="fas fa-plus"></i> ADD TASK</Button>
        <Form.Text>
          {user?<p style={{color:'green'}}>Your todo list will be secure with us!</p>:<p>Please signed in to add task.{data}</p>}
        </Form.Text>
    </Form.Group>
    
  </Form>
  
  </Container>
  );
}

function NewlineText(props) {
  const text = props.text;
  return text.split('\n').map(str => <p>{str}</p>);
}

const TodoData = () =>{

  const ref = firestore.collection('todoList').doc(auth.currentUser.uid).collection('list');
  const [todoData,todoDataLoading] = useCollectionData(ref.orderBy('createdAt','desc'),{idField:"id"});

  const completeTask = (id) =>{
    Swal.fire({
      title:"Do you want to set this task to completed?",
      icon:"question",
      confirmButtonText:"Complete",
      cancelButtonText:"Not yet!",
      showCancelButton:true,
      showLoaderOnConfirm:true,
      preConfirm:async()=>{
        return await ref.doc(id).update({
          completed:true
        }).then(async()=>{
            return await firestore.collection('home').doc(id).update({
              completed:true
            })
        })
      }
    }).then(res=>{
      if(res.value){
        Swal.fire('Task Completed','','success');
      }
    }) 
  }

  const removeTask = (id)=>{
    Swal.fire({
      title:"Do you want to remove this task?",
      icon:"question",
      confirmButtonText:"Remove",
      showCancelButton:true,
      showLoaderOnConfirm:true,
      preConfirm:async()=>{
        return await ref.doc(id).delete().then(async()=>{
          return await firestore.collection('home').doc(id).delete();
        });
      }
    }).then(res=>{
      if(res.value){
        Swal.fire('Task Deleted','','success');
      }
    })
  }
  return (
      <Container style={{marginTop:"15px"}}>
      <Container>

      {
        todoDataLoading?<div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
        <Spinner variant="primary" animation="border" role="status"><span className="sr-only">Loading...</span> </Spinner></div>:
        <ListGroup as="ul">
          {todoData&&todoData.map((list)=>(
            <List completeTask={completeTask} createdAt={list.createdAt} id={list.id} removeTask={removeTask} text={list.text} complete={list.completed} key={list.id}/>
          ))}
        </ListGroup>
      }
      </Container>
      </Container>

  );
}

const List = ({text,complete,completeTask,removeTask,createdAt,id}) =>{
  const textAreaRef = useRef(null);
  function formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }
  
  return (
    <ListGroup.Item  style={{background:"#222",borderBottom:"1px solid grey"}}  variant={complete?'success':'dark'}>
       
      <Row>
        <Col xs={12} sm={6} md={7} lg={8}>
          <pre ref={textAreaRef}>
            <code className="MyTask" style={{textDecoration:complete?"line-through":null,color:'white',lineHeight:"80%",fontWeight:"bolder"}}>
              <NewlineText text={text} />  
            </code>
          </pre>
          {complete?
            <Badge variant="success">{new Date(createdAt).toString().slice(4,15)} {formatAMPM(new Date(createdAt))}</Badge>:
            <Badge variant="danger"><TimeAgo date={createdAt}/></Badge>
          }
          &nbsp;
          {/* <Badge style={{cursor:"pointer"}} onClick={editTodo} variant="danger" size="sm">copy code</Badge> */}
        </Col>
        <Col sm={6} md={5} lg={4} style={{textAlign:"right"}}>
          {complete &&<Badge>completed <i className="far fa-check-circle"></i></Badge>}
          {!complete && 
            <Badge variant="danger" onClick={()=>completeTask(id)}  style={{cursor:'pointer'}}>
              Mark complete <i className="fas fa-plus-circle"></i>
            </Badge>}  
          &nbsp;&nbsp;&nbsp;&nbsp;
          <Badge onClick={()=>removeTask(id)} style={{cursor:"pointer"}} variant="danger">Remove <i className="fas fa-backspace"></i></Badge>
        </Col>
      </Row>

    </ListGroup.Item>
  );
}
export default App;